import { useState, useRef, useCallback } from 'react';
import { useReactToPrint } from 'react-to-print';

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export interface UsePrintProps {
    documentTitle?: string;
}

export const usePrint = ({ documentTitle = 'document' }: UsePrintProps) => {
    const componentRef = useRef<HTMLDivElement>(null);
    const [isPrintLoading, setIsPrintLoading] = useState(false);

    const handlePrint = useReactToPrint({
        contentRef: componentRef,
        documentTitle,
    });

    const print = useCallback(async () => {
        setIsPrintLoading(true);
        await sleep(10);
        handlePrint();
        await sleep(1000);
        setIsPrintLoading(false);
    }, [handlePrint]);

    return { componentRef, print, isPrintLoading };
};
